<!-- Minimized draggable bubble -->
<div class="softphone-bubble" #draggableEl
  *ngIf="voipConfigured && !isExpanded && state === 'idle'"
  [ngStyle]="getDragStyle()"
  (mousedown)="onDragStart($event)"
  (touchstart)="onTouchStart($event)"
  (click)="toggle()">
  <i class="icon-phone"></i>
  <span class="status-indicator" [style.background]="getStatusColor()"></span>
  <span class="drag-hint">{{ "communication.voip.drag_hint" | translate }}</span>
</div>

<!-- Mini bar (during call, minimized) -->
<div class="softphone-mini-bar" #draggableEl
  *ngIf="voipConfigured && isMinimized && (state === 'in-call' || state === 'on-hold' || state === 'ringing' || state === 'dialing')"
  [ngStyle]="getDragStyle()"
  (mousedown)="onDragStart($event)"
  (touchstart)="onTouchStart($event)"
  (click)="toggle()">
  <div class="mini-pulse" [class.on-hold]="state === 'on-hold'"></div>
  <span class="mini-number">{{ contactName || phoneNumber }}</span>
  <span class="mini-timer" *ngIf="state === 'in-call' || state === 'on-hold'">{{ formatDuration(callDuration) }}</span>
  <button class="mini-hangup" (click)="hangup(); $event.stopPropagation()">
    <i class="icon-phone-error"></i>
  </button>
</div>

<!-- Expanded widget -->
<div class="softphone-widget" #draggableEl
  *ngIf="voipConfigured && (isExpanded || (!isMinimized && state !== 'idle'))"
  [ngStyle]="getDragStyle()">
  <!-- Header (draggable) -->
  <div class="widget-header"
    (mousedown)="onDragStart($event)"
    (touchstart)="onTouchStart($event)">
    <div class="header-left">
      <i class="icon-phone"></i>
      <span>{{ "communication.voip.softphone" | translate }}</span>
    </div>
    <div class="header-right">
      <span class="status-dot" [style.background]="getStatusColor()"></span>
      <button class="btn-minimize" (click)="toggle(); $event.stopPropagation()">
        <i class="icon-chevron-down"></i>
      </button>
    </div>
  </div>

  <!-- Idle state: Dialpad -->
  <div class="widget-body" *ngIf="state === 'idle'">
    <div class="number-display">
      <i class="icon-magnifier search-icon"></i>
      <input type="text" [(ngModel)]="phoneNumber" placeholder="+34..." class="phone-input" />
      <button class="btn-backspace" *ngIf="phoneNumber" (click)="backspace()">
        <i class="icon-cross"></i>
      </button>
    </div>

    <div class="dialpad">
      <button class="dialpad-key" *ngFor="let key of dialpadKeys" (click)="pressKey(key.digit)">
        <span class="key-digit">{{ key.digit }}</span>
        <span class="key-letters" *ngIf="key.letters">{{ key.letters }}</span>
      </button>
    </div>

    <div class="call-actions">
      <button class="btn-call" [disabled]="!phoneNumber" (click)="call()">
        <i class="icon-phone"></i>
      </button>
    </div>
  </div>

  <!-- Calling state -->
  <div class="widget-body calling-state" *ngIf="state === 'dialing' || state === 'ringing'">
    <div class="call-pulse-ring">
      <div class="call-pulse"></div>
      <i class="icon-phone"></i>
    </div>
    <p class="calling-name" *ngIf="contactName">{{ contactName }}</p>
    <p class="calling-number">{{ phoneNumber }}</p>
    <p class="calling-label">{{ getStateLabel() | translate }}...</p>
    <button class="btn-hangup" (click)="hangup()">
      <i class="icon-phone-error"></i>
    </button>
  </div>

  <!-- In call state -->
  <div class="widget-body in-call-state" *ngIf="state === 'in-call' || state === 'on-hold'">
    <div class="call-active-indicator" [class.on-hold]="state === 'on-hold'">
      <i class="icon-phone"></i>
    </div>
    <p class="calling-name" *ngIf="contactName">{{ contactName }}</p>
    <p class="calling-number" *ngIf="!contactName">{{ phoneNumber }}</p>
    <p class="call-timer">{{ formatDuration(callDuration) }}</p>
    <p class="calling-label" *ngIf="state === 'on-hold'">{{ "communication.voip.on_hold" | translate }}</p>

    <div class="in-call-controls">
      <button class="control-btn" [class.active]="isMuted" (click)="toggleMute()">
        <i [class]="isMuted ? 'icon-mic-mute' : 'icon-mic'"></i>
        <span>{{ (isMuted ? "communication.voip.unmute" : "communication.voip.mute") | translate }}</span>
      </button>
      <button class="control-btn" [class.active]="state === 'on-hold'" (click)="toggleHold()">
        <i class="icon-pause-circle"></i>
        <span>{{ "communication.voip.hold" | translate }}</span>
      </button>
    </div>

    <button class="btn-hangup" (click)="hangup()">
      <i class="icon-phone-error"></i>
    </button>
  </div>

  <!-- Post call -->
  <div class="widget-body post-call-state" *ngIf="state === 'post-call'">
    <div class="post-call-header">
      <i class="icon-check text-success"></i>
      <p>{{ "communication.voip.call_ended" | translate }}</p>
      <span class="post-call-duration">{{ formatDuration(callDuration) }}</span>
    </div>
    <p class="post-call-number">{{ contactName || phoneNumber }}</p>
    <div class="post-call-info">
      <p class="text-muted small">{{ "communication.voip.post_call_hint" | translate }}</p>
    </div>
    <button class="btn btn-primary btn-sm w-100" (click)="endPostCall()">
      {{ "communication.voip.new_call" | translate }}
    </button>
  </div>
</div>
